import * as turf from "@turf/turf";
export const calculateBoundingBox = (
  latitude: number,
  longitude: number,
  distanceKm: number,
) => {
  // Create a point
  const point = turf.point([longitude, latitude]);

  // Create a buffer around the point (distance in kilometers)
  const buffered = turf.buffer(point, distanceKm, { units: "kilometers" });

  // Get the bounding box of the buffer
  const bbox = turf.bbox(buffered);
  return bbox;
};
